import { FocusScope } from "@react-aria/focus"
import { motion, AnimatePresence } from "framer-motion"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import DropdownContent from "./dropdown-content"

const variants = {
  hide: {
    height: 0,
    transition: { ease: "easeOut" },
    transitionEnd: { display: "none" },
  },
  show: {
    display: "block",
    height: "auto",
    transition: { ease: "easeOut" },
  },
}

const InternalDesktopDropdown = ({ dropdownMenu, showSubmenu }) => (
  <AnimatePresence>
    {dropdownMenu && showSubmenu && (
      <motion.div
        animate="show"
        className="border-grey-20 min-w-160 absolute z-50 overflow-hidden border bg-white text-left shadow-lg"
        exit="hide"
        id="nav_dropdown_menu"
        initial="hide"
        variants={variants}
      >
        <FocusScope contain restoreFocus>
          <DropdownContent />
        </FocusScope>
      </motion.div>
    )}
  </AnimatePresence>
)

InternalDesktopDropdown.propTypes = {
  dropdownMenu: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  showSubmenu: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    dropdownMenu: state.menu.desktopSubmenu,
    showSubmenu: state.menu.showSubmenu,
  }
}

const mapDispatchToProps = () => ({})

const DesktopDropdown = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalDesktopDropdown)

export default DesktopDropdown
